interface HeaderButton {
  label: string;
  icon?: string;
  permissions?: string[];
  visible: () => boolean;
  action: () => void;
}

export interface HeaderOptions {
  title: string;
  buttons?: {
    left?: HeaderButton;
    right?: HeaderButton;
  };
}
